export function redirectToSignedOutSignIn() {
  window.location.replace('/?auth=signin&signed_out=1');
}
